import React from 'react';
import { View } from 'react-native';

import MachineOffline from './machineOffline';
import NcFileContent from './ncFileContent';
import NcFileIgnored from './ncFileIgnored';
import ConnectingMachine from './connectingMachine';

import { isPhone, machineDetailsConditions } from '@helpers';
import { scale as initialScale } from '@components/frame';
import { font as initialFont } from '@styles/fonts';
import { DetailsComponentProps } from '@v2/pages/machines/common/types/props';

import { connect } from 'react-redux';

const DetailsComponents = (props: DetailsComponentProps) => {
  const { C, font = initialFont, scale = initialScale, panelViewMode, noMachine, machinesLoaded, initialLoading, children, selectedItem } = props;

  const { ncFileStatus, status, subStatus, ncFile } = selectedItem?.machineStatus || {};

  const { machineOffline, noSelectedNCFileSubStatusButNCFileExist } = machineDetailsConditions({
    status,
    ncFileStatus,
    subStatus,
    ncFileExist: !!ncFile,
  });

  if (!noMachine && (!machinesLoaded || initialLoading)) {
    return (
      <View
        style={{
          width: '100%',
          flex: 1,
        }}
      >
        <ConnectingMachine {...props} />
      </View>
    );
  }

  if (!noMachine && machineOffline) {
    return (
      <View
        style={{
          width: '100%',
          flex: 1,
          paddingTop: scale(isPhone ? 74 : 76),
        }}
      >
        <MachineOffline {...props} />
      </View>
    );
  }

  if (noSelectedNCFileSubStatusButNCFileExist) {
    return (
      <View
        style={[
          {
            width: '100%',
            alignItems: 'center',
            flex: 1,
          },
        ]}
      >
        <View
          style={[
            { width: '100%', alignItems: 'center' },
            !!panelViewMode && { flex: 1 },
            !noSelectedNCFileSubStatusButNCFileExist && { height: scale(279) },
          ]}
        >
          <NcFileIgnored {...{ selectedItem, C, font, noSelectedNCFileSubStatusButNCFileExist }} />
        </View>
        <View style={[{ marginTop: scale(isPhone ? 14 : 21), width: '100%', flex: 1, paddingBottom: scale(isPhone ? 0 : 18) }]}>
          <NcFileContent {...{ ...props, font }} />
        </View>
      </View>
    );
  }

  return (
    <View
      style={{
        width: '100%',
        flex: 1,
      }}
    >
      <View style={{ width: '100%', flex: 1 }}>{children}</View>
    </View>
  );
};

export default connect(({ machines: { selectedItem } }) => ({ selectedItem }), {})(DetailsComponents);
